<app-layout-main [pageMetadata]="{ title: appName() }" [layoutSize]="'small'" [design]="'focused'">
	<lib-focused-card [title]="'Unsubscribe'">
		@if (malformedRequest()) {
		<div>
			<lib-message [type]="'warning'">The request for unsubscribe is malformed</lib-message>
		</div>
		} @else { @if (!formSubmitted()) {

		<div>
			By clicking on the button below you will be unsubscribed from receiving all non-essentials e-mails from our
			systems.
		</div>

		<div class="push-top">
			<ui-form-save-button
				[title]="'Unsubscribe'"
				[saveHandler]="saveHandler()"
				[enableEnterSaveShortcut]="false"
				[logHandler]="formLogHandler()"
			></ui-form-save-button>
		</div>

		} @else {
		<lib-message [type]="'success'">You have been successfully unsubscribed.</lib-message>
		} }
	</lib-focused-card>
</app-layout-main>
